'use client';

import { useEffect, useRef, useState } from 'react';
import { ClusteredMarkers } from '../clustered-markers';

interface MapProps {
  center: google.maps.LatLngLiteral;
  zoom: number;
  style?: React.CSSProperties;
  mapId: string;
  className?: string;
  gestureHandling?: 'cooperative' | 'greedy' | 'none';
  streetViewControl?: boolean;
  children?: React.ReactNode;
}

export const GoogleMap: React.FC<MapProps> = ({
  center,
  zoom,
  style,
  className,
  mapId,
  gestureHandling,
  streetViewControl,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<google.maps.Map | null>(null);

  useEffect(() => {
    if (!ref.current || typeof google === 'undefined') return;

    const mapInstance = new google.maps.Map(ref.current, {
      center,
      zoom,
      disableDefaultUI: false,
      mapId,
    });

    setMap(mapInstance);

    return () => {
      google.maps.event.clearInstanceListeners({});
    };
  }, []);

  useEffect(() => {
    if (map) {
      map.setCenter(center);
      map.setZoom(zoom);
    }
  }, [center, zoom, map]);

  return (
    <div ref={ref} className={className} style={{ ...style }}>
      <ClusteredMarkers map={map} />
    </div>
  );
};
